import { defineStore } from 'pinia'
import { ref } from 'vue'
import { UserProfileData } from '../types/userProfile/userProfileData'

export const useUserProfileStore = defineStore('userProfile', () => {
  const profile = ref<UserProfileData | null>(null)
  const isLoggedIn = ref<boolean>(false)

  function setIsLoggedIn(value: boolean): void {
    isLoggedIn.value = value
  }

  function setUserProfile(user: UserProfileData): void {
    profile.value = user
    setIsLoggedIn(true)
  }

  function updateIdToken(newToken: string): void {
    if (profile.value) {
      profile.value.idToken = newToken
      console.log('Updated ID token in userProfileStore')
    } else {
      console.warn('Cannot update token — no active profile found.')
    }
  }

  function clearUserProfile(): void {
    setIsLoggedIn(false)
    profile.value = null
    localStorage.clear()
    if (window.google?.accounts?.id) {
      window.google.accounts.id.disableAutoSelect()
    }
  }

  return {
    profile,
    isLoggedIn,
    setIsLoggedIn,
    setUserProfile,
    updateIdToken,
    clearUserProfile,
  }
})
